export default {
  cancelReasonLabel: 'Reason',
  cancelCommentLabel: 'Comment',
  cancel: 'Cancel'
};
